import axios from "../../axios"

export default {
  async registerAccess(tenant, token)
  {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + 'api/accesses'
    try{
      let header = {
        headers: {
          Authorization: "Bearer " + token
        }
      }
      
      await axios.post('', {"tenant": tenant}, header)
      return true
    }catch(Exception)
    {
      return false;
    }
  },

}